import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  diagnosisPopup: {
    [theme.breakpoints.down('sm')]: {
      dding: '0px !important'
    },

    '& .popup__box': {
      maxWidth: 800,
      width: '90vw',
      maxHeight: '92vh',
      height: '92vh',
      overflow: 'hidden',
      position: 'relative',
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      transition: 'max-width 0.3s ease, width 0.3s ease',

      [theme.breakpoints.down('sm')]: {
        width: '100vw',
        height: '100vh',
        maxWidth: '100vw',
        maxHeight: '100vh',
        borderRadius: 0
      }
    },

    '& .popup__box h1': {
      flexShrink: 0,
      zIndex: 2,
      margin: 0,
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      padding: '20px 64px 16px 24px',
      backgroundColor: theme.palette.background.default,
      borderBottom: '1px solid ' + theme.palette.divider
    },

    '& .popup__close-icon': {
      position: 'absolute',
      top: 20,
      right: 24,
      zIndex: 3
    },

    '& .popup__header-badge': {
      marginLeft: 'auto',
      marginRight: 40
    },

    '& .popup__main': {
      marginTop: 0,
      padding: '16px 24px 16px 24px',
      flex: 1,
      minHeight: 0,
      overflowX: 'hidden',
      overflowY: 'hidden',

      [theme.breakpoints.down('sm')]: {
        padding: '0 16px 12px 16px',
        marginTop: 8,
        maxHeight: 'unset !important'
      }
    }
  },

  diagnosisPopupAnimalForm: {
    '& .popup__box': {
      maxWidth: 1200,
      width: '100%'
    }
  },

  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    gap: 8,

    [theme.breakpoints.down('sm')]: {
      gap: 0
    }
  },

  contentContainer: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingRight: 0,
    '& .MuiGrid-container': {
      margin: 0,
      width: '100%'
    }
  },

  radioGroup: {
    display: 'flex',
    gap: 24,
    alignItems: 'center',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 12
    }
  },

  actionsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10,
    marginTop: 12,
    flexShrink: 0,
    zIndex: 2,
    backgroundColor: theme.palette.background.default,
    padding: '12px 0 0 0',
    borderTop: '1px solid ' + theme.palette.divider,

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexDirection: 'column'
    }
  },

  buttonWrapper: {
    width: 'max-content',
    display: 'flex',
    padding: '8px 16px 8px 12px',
    gap: 8,

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  buttonOutlined: {
    backgroundColor: 'transparent',
    border: '1px solid ' + theme.palette.primary.main,
    color: theme.palette.primary.main
  },

  infoSection: {
    marginBottom: 16
  },

  section: {
    marginBottom: 24,
    padding: 16,
    border: '1px solid ' + theme.palette.divider,
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper
  },

  sectionTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 16,
    color: theme.palette.primary.main
  },

  reproductionTypeInfo: {
    marginBottom: 16
  },

  formRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 16,

    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: 12
    }
  },

  formControl: {
    marginBottom: 0
  },

  pendingDiagnosisContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    padding: 16,
    marginBottom: 16,
    border: '1px solid ' + theme.palette.divider,
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper,
    textAlign: 'center'
  },

  pendingDiagnosisContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 12
  },

  pendingDiagnosisIcon: {
    fontSize: 32,
    color: theme.palette.primary.main
  },

  pendingDiagnosisText: {
    fontSize: 16,
    color: theme.palette.primary.main,
    fontWeight: 500
  },

  savedBirthsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    marginBottom: 16
  },

  addBirthButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 16,
    marginBottom: 16,

    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center'
    }
  },

  backButtonContainer: {
    marginBottom: 16,
    flexShrink: 0,
    backgroundColor: theme.palette.background.default,
    paddingBottom: 8,
    borderBottom: '1px solid ' + theme.palette.divider
  },

  backIcon: {
    fontSize: 20,
    marginRight: 4
  },

  formContentWrapper: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingTop: 8,
    paddingBottom: 8
  }
}))
